<template>
  <div class="content-page">
    <div class="mian-page">
      <div class="title-page"></div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <!-- 返回按钮和文件名在同一行 -->
          <div class="header-bar">
            <span class="back-btn" @click="handleBack">‹返回</span>
            <span class="file-name-display">{{ evidenceName }}</span>
            <span class="download-action">
              <button v-if="downloadPath" class="header-download-btn" @click="handleDownload" title="下载文件">
                <i class="el-icon-download"></i>
              </button>
            </span>
          </div>
        </div>
        
        <!-- 全屏水印 -->
        <div v-if="watermarkText" class="watermark">
          <span 
            v-for="(item, index) in watermarkItems" 
            :key="index" 
            class="watermark-text"
          >{{ watermarkText }}</span>
        </div>
        
        <!-- 预览内容区域 -->
        <div class="preview-container">
          <previewPDF :evidenceType="evidenceType" :evidencePath="evidencePath" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import previewPDF from '@/components/previewPDF/previewPDF'
import Api from '@/api/api'

export default {
  name: 'FilePreview',
  components: {
    previewPDF
  },
  data() {
    return {
      evidencePath: '',
      evidenceType: '',
      evidenceName: '',
      applicantName: '',
      filingTime: '',
      downloadPath: '',
      caseOrderNo: '',
      filePath: '',
      watermarkText: '',
      watermarkItems: Array.from({ length: 30 }, (_, i) => i) // 生成30个水印项（5列6行）
    }
  },
  mounted() {
    const { evidencePath, evidenceType, evidenceName, applicantName, filingTime, downloadPath, caseOrderNo, filePath } = this.$route.query
    this.evidencePath = decodeURIComponent(evidencePath || '')
    this.evidenceType = evidenceType || ''
    this.evidenceName = decodeURIComponent(evidenceName || '')
    this.applicantName = decodeURIComponent(applicantName || '')
    this.filingTime = decodeURIComponent(filingTime || '')
    this.downloadPath = decodeURIComponent(downloadPath || '') || this.evidencePath
    this.caseOrderNo = caseOrderNo || ''
    this.filePath = decodeURIComponent(filePath || '')

    // 生成水印文本
    this.generateWatermarkText()
  },
  methods: {
    handleBack() {
      this.$router.back()
    },
    /**
     * 生成水印文本
     */
    generateWatermarkText() {
      let watermarkText = ''
      if (this.applicantName) {
        watermarkText = `申请人${this.applicantName}`
        if (this.filingTime) {
          watermarkText += `，申请时间：${this.filingTime}`
        }
      }
      this.watermarkText = watermarkText
    },
    /**
     * 组装下载文件名：evidenceName 为展示名可能无后缀，
     * 若缺失则从 filePath 中补齐扩展名
     */
    buildDownloadName() {
      const base = this.evidenceName || '阅卷材料'
      const extMatch = /\.[^./\\]+$/.exec(this.filePath || '')
      const ext = extMatch ? extMatch[0] : ''
      console.log('[DEBUG-dl] evidenceName:', this.evidenceName, 'filePath:', this.filePath, 'ext:', ext, 'base:', base)
      if (ext && !base.toLowerCase().endsWith(ext.toLowerCase())) {
        return base + ext
      }
      return base
    },
    async handleDownload() {
      if (!this.caseOrderNo || !this.filePath) {
        this.$message.error('缺少下载参数')
        return
      }
      const loading = this.$loading({ lock: true, text: '文件处理中...' })
      try {
        const res = await Api.downloadReviewFile({
          caseOrderNo: this.caseOrderNo,
          filePath: this.filePath,
          fileName: this.buildDownloadName()
        })
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = this.buildDownloadName()
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error((e && e.message) || '下载失败')
      } finally {
        loading.close()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mian-page {
  height: 100%;
  
  .backgroundBox {
    height: calc(100% - 100px);
    position: relative;
    display: flex;
    flex-direction: column;
    background-size: 112% 112%!important;
    
    .main-contentBox {
      padding: 20px 20px 0;
      flex-shrink: 0;
      width: 100%;
      
      .header-bar {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        font-size: 16px;
        color: #333;
        line-height: 1.5;
        
        .back-btn {
          cursor: pointer;
          flex: 0 0 80px;
          font-weight: 500;
          color: #287AFD;

          &:hover {
            color: #287AFD;
          }
        }
        
        .file-name-display {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          flex: 1;
          min-width: 0;
        }
      }
    }
  }
}

.watermark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 99;
  overflow: hidden;
  
  .watermark-text {
    position: absolute;
    color: rgba(0, 0, 0, 0.15);
    font-size: 16px;
    white-space: nowrap;
    transform: rotate(-45deg);
    user-select: none;
  }
  
  // 水印位置分布 - 5列6行排列
  // 第一列
  .watermark-text:nth-child(1) { top: 0%; left: 0%; }
  .watermark-text:nth-child(2) { top: 20%; left: 0%; }
  .watermark-text:nth-child(3) { top: 40%; left: 0%; }
  .watermark-text:nth-child(4) { top: 60%; left: 0%; }
  .watermark-text:nth-child(5) { top: 80%; left: 0%; }
  .watermark-text:nth-child(6) { top: 100%; left: 0%; }
  // 第二列
  .watermark-text:nth-child(7) { top: 0%; left: 20%; }
  .watermark-text:nth-child(8) { top: 20%; left: 20%; }
  .watermark-text:nth-child(9) { top: 40%; left: 20%; }
  .watermark-text:nth-child(10) { top: 60%; left: 20%; }
  .watermark-text:nth-child(11) { top: 80%; left: 20%; }
  .watermark-text:nth-child(12) { top: 100%; left: 20%; }
  // 第三列
  .watermark-text:nth-child(13) { top: 0%; left: 40%; }
  .watermark-text:nth-child(14) { top: 20%; left: 40%; }
  .watermark-text:nth-child(15) { top: 40%; left: 40%; }
  .watermark-text:nth-child(16) { top: 60%; left: 40%; }
  .watermark-text:nth-child(17) { top: 80%; left: 40%; }
  .watermark-text:nth-child(18) { top: 100%; left: 40%; }
  // 第四列
  .watermark-text:nth-child(19) { top: 0%; left: 60%; }
  .watermark-text:nth-child(20) { top: 20%; left: 60%; }
  .watermark-text:nth-child(21) { top: 40%; left: 60%; }
  .watermark-text:nth-child(22) { top: 60%; left: 60%; }
  .watermark-text:nth-child(23) { top: 80%; left: 60%; }
  .watermark-text:nth-child(24) { top: 100%; left: 60%; }
  // 第五列
  .watermark-text:nth-child(25) { top: 0%; left: 80%; }
  .watermark-text:nth-child(26) { top: 20%; left: 80%; }
  .watermark-text:nth-child(27) { top: 40%; left: 80%; }
  .watermark-text:nth-child(28) { top: 60%; left: 80%; }
  .watermark-text:nth-child(29) { top: 80%; left: 80%; }
  .watermark-text:nth-child(30) { top: 100%; left: 80%; }
}

.preview-container {
  flex: 1;
  width: 100%;
  height: 0; // 使用flex布局时设置为0，让flex:1生效
  overflow-y: auto;
  position: relative;
  z-index: 1;
  text-align: center;
  
  ::v-deep .preview-container {
    height: 100%;
  }
}

.download-action {
  flex: 0 0 80px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.header-download-btn {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: #5a84f7;
  color: #fff;
  font-size: 18px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 2px 16px rgba(67, 80, 141, 0.24);
  padding: 0;

  &:hover {
    background: #4a78f2;
  }
}
</style>

